// get data for current users room and current area id
// https://mccglc.atlassian.net/l/c/hXKp0WFb for DOCS

const state = {
  redirectUrl: 'https://www.spacein.co.uk/already-open',
};

const getters = {
  getRedirectUrl: (state) => state.redirectUrl,
};

const mutations = {

};

const actions = {
  async multipleTabRedirect({getters, dispatch}) {
    await dispatch('analytics/forcedShutdown')
    window.location = getters.getRedirectUrl
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
